module.exports = "<svg style=\"width: 15px; height: 3px;\" viewBox=\"0 6 15 3\"><path d=\"M1.5,9 C2.32842712,9 3,8.32842712 3,7.5 C3,6.67157288 2.32842712,6 1.5,6 C0.671572875,6 0,6.67157288 0,7.5 C0,8.32842712 0.671572875,9 1.5,9 Z M7.5,9 C8.32842712,9 9,8.32842712 9,7.5 C9,6.67157288 8.32842712,6 7.5,6 C6.67157288,6 6,6.67157288 6,7.5 C6,8.32842712 6.67157288,9 7.5,9 Z M13.5,9 C14.3284271,9 15,8.32842712 15,7.5 C15,6.67157288 14.3284271,6 13.5,6 C12.6715729,6 12,6.67157288 12,7.5 C12,8.32842712 12.6715729,9 13.5,9 Z\" id=\"path-1\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./assets/icons/more.svg
// module id = 1297
// module chunks = 0